var MS_IN_24_HOURS = 1000 * 60 * 60 * 24;
export var getMonthNameByMonthNumber = function getMonthNameByMonthNumber(num) {
  var errorMessage = 'getMonthNameByMonthNumber function expects a valid argument';
  if (!num) throw new Error(errorMessage);
  var month = '';
  switch (num) {
    case 1:
      month = 'Jan';
      break;
    case 2:
      month = 'Feb';
      break;
    case 3:
      month = 'Mar';
      break;
    case 4:
      month = 'Apr';
      break;
    case 5:
      month = 'May';
      break;
    case 6:
      month = 'Jun';
      break;
    case 7:
      month = 'Jul';
      break;
    case 8:
      month = 'Aug';
      break;
    case 9:
      month = 'Sep';
      break;
    case 10:
      month = 'Oct';
      break;
    case 11:
      month = 'Nov';
      break;
    case 12:
      month = 'Dec';
      break;
    default:
      throw new Error(errorMessage);
  }
  return month;
};
export var hasDatePassed = function hasDatePassed(date) {
  var point = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
  return date.valueOf() - point.valueOf() < 0;
};
export var getDaysPassedBetweenDates = function getDaysPassedBetweenDates(_ref) {
  var startDate = _ref.startDate,
    endDate = _ref.endDate;
  return (endDate.valueOf() - startDate.valueOf()) / MS_IN_24_HOURS + 1;
};
export var getHumanisedTextFromNumberOfDays = function getHumanisedTextFromNumberOfDays(numberOfDays) {
  var years = Math.floor(numberOfDays / 365);
  var days = Math.floor(numberOfDays % 365 % 30);
  var months = Math.floor(numberOfDays % 365 / 30);
  var roundedUpMonths = months + (days > 0 && (months >= 1 || years >= 1) ? 1 : 0);
  return [years > 0 ? years + (years === 1 ? ' Yr' : ' Yrs') : false, roundedUpMonths > 0 ? roundedUpMonths + (roundedUpMonths === 1 ? ' Mth' : ' Mths') : false, months < 1 && years < 1 && days > 0 ? days + (days === 1 ? ' Day' : ' Days') : false].filter(Boolean).join(', ');
};
export var getPercentageProgressBetweenDates = function getPercentageProgressBetweenDates(_ref2) {
  var startDate = _ref2.startDate,
    endDate = _ref2.endDate,
    _ref2$progressPointDa = _ref2.progressPointDate,
    progressPointDate = _ref2$progressPointDa === void 0 ? Date.now() : _ref2$progressPointDa;
  if (progressPointDate.valueOf() > endDate.valueOf()) return 100;
  if (startDate.valueOf() > progressPointDate.valueOf()) return 0;
  var timeActivityWillTake = startDate.valueOf() - endDate.valueOf();
  var timeSpent = startDate.valueOf() - progressPointDate.valueOf();
  return timeSpent / timeActivityWillTake * 100;
};
export var getIsoToHumanizeDate = function getIsoToHumanizeDate(isoDate) {
  var errorMessage = 'getIsoToHumanizeDate function expects a valid iso date argument';
  if (!isoDate) throw new Error(errorMessage);
  var date = new Date(isoDate);
  return "".concat(date.getDate(), " ").concat(getMonthNameByMonthNumber(date.getMonth() + 1), ", ").concat(date.getFullYear());
};